import { render } from "./PageHeader.vue.js?vue&type=template&id=7febe318!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageHeader.vue?vue&type=template&id=7febe318"
import script from "./PageHeader.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/PageHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7febe318"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7febe318', __exports__)) {
    api.reload('7febe318', __exports__)
  }
  
  module.hot.accept("./PageHeader.vue.js?vue&type=template&id=7febe318!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PageHeader.vue?vue&type=template&id=7febe318", () => {
    api.rerender('7febe318', render)
  })

}


export default __exports__